import { render, staticRenderFns } from "./PostSearch.vue?vue&type=template&id=40f82d66&scoped=true&"
import script from "./PostSearch.vue?vue&type=script&lang=ts&"
export * from "./PostSearch.vue?vue&type=script&lang=ts&"
import style0 from "./PostSearch.vue?vue&type=style&index=0&id=40f82d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f82d66",
  null
  
)

export default component.exports